"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('lark', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0721 5.99409L3.31119 16.5187L12.3861 25.8126L20.8003 25.9594L30.4832 16.5187C30.2271 15.9943 30.099 15.5552 30.099 15.2013C30.099 14.4074 30.4108 13.7786 30.8952 13.333C31.7246 12.57 32.7226 12.4558 33.8894 12.9905L41.0721 5.99409Z",
    fill: props.outStrokeColor
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1028 6.72854L31.5782 44.4895L22.2844 35.4146L22.1375 27.0004L31.5122 17.4817C32.0202 17.8456 32.575 18.0106 33.1766 17.977C34.0791 17.9265 34.6621 17.3814 34.9356 17.0604C35.2091 16.7393 35.53 16.2052 35.5033 15.4114C35.4854 14.8822 35.3116 14.3942 34.982 13.9473L42.1028 6.72854Z",
    fill: props.outStrokeColor
  }));
});

exports.default = _default;